import { createTranslations } from '@npco/utils-translations'

export const accessDeniedTranslations = createTranslations({
  title: "You don't have permission to view this page yet.",
  description:
    'You are unable to view Reports as a Manager. Please contact your Admin if you require access to this page.',
})
